import { createFileRoute } from '@tanstack/react-router';

import { OrganizationDetailPage, organizationQueryOptions } from '@/features/organizations';

export const Route = createFileRoute('/_authed/organizations/$organizationId')({
  staticData: {
    tours: ['platform.organizations.detail', 'platform.organizations.detail-actions'],
  },
  loader: async ({ context, params }) => {
    const organization = await context.queryClient.query({
      ...organizationQueryOptions(params.organizationId),
      staleTime: 'static',
    });
    // The shell's breadcrumb reads this; the page itself subscribes to the query.
    return { crumb: organization.name };
  },
  component: OrganizationDetailPage,
});
